module.exports = __webpack_public_path__ + "assets/apple-touch-icon-152-devel-dc93be.png";